import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import analysts_Architect_INTJ_personality_header from '../../images/personality_types_details/analysts_Architect_INTJ_personality_header.svg'
import analysts_Architect_INTJ_strengths from '../../images/personality_types_details/analysts_Architect_INTJ_strengths.svg'
import analysts_Architect_INTJ_weaknesses from '../../images/personality_types_details/analysts_Architect_INTJ_weaknesses.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const intj_strengths_and_weaknesses = () => {
    return (
        <Layout>
            <main className="q-td analyst architect">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/architect-intj-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-strengths-and-weaknesses" className="tab with-progress active">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-friends" className="tab with-progress ">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-careers" className="tab with-progress ">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intjs-at-work" className="tab with-progress ">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header className="type-header analyst architect">
                    <svg className="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path className="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path className="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>
                    <img src={analysts_Architect_INTJ_personality_header} className="scene" alt='loading...' />
                    <div className="type-info">
                        <h1><span>Architect</span> Personality</h1>
                        <div className="code">INTJ-A / INTJ-T</div>
                        <a href="#" className="difference">(What’s the difference?)</a>
                    </div>
                </header>


                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/architect-intj-personality'>Introduction</Link></li>
                                <li className="active"><Link to="/personality-types/architect-intj-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-parents">Parenthood</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/architect-intjs-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}

                    <article className="main description">

                        <h1>Strengths &amp; Weaknesses</h1>

                        <h2>Architect (INTJ) Strengths</h2>

                        <div className="scene"><img alt="Architect (INTJ) strengths" src={analysts_Architect_INTJ_strengths} /></div>

                        <ul>

                            <li><strong>Rational</strong> – Architects pride themselves on their minds. For them, nearly any situation can become an opportunity to expand their knowledge and hone their rational thinking skills. Thanks to this mindset, they can devise inventive solutions to even the most arduous of problems.</li>

                            <li><strong>Informed</strong> – Few personality types are as devoted as Architects to forming rational, evidence-based opinions. Rather than hunches or half-baked assumptions, they base their conclusions on research and analysis. This gives them the self-assurance they need to stand up for their ideas, even in the face of disagreement.</li>

                            <li><strong>Independent</strong> – For these personality types, conformity is more or less synonymous with mediocrity. Creative and self-motivated, Architects strive to do things their own way. They can imagine few things more frustrating than allowing rules or conventions to stand in the way of their success.</li>

                            <li><strong>Determined</strong> – Architect personalities are ambitious and goal-oriented. Whenever an idea or pursuit captures their imagination, Architects dedicate themselves to mastering the subject and gaining relevant skills. They tend to have clear visions of what it means for them to be successful, and few things can deter them from turning these visions into reality.</li>

                            <li><strong>Curious</strong> – Architects are open to new ideas – as long as those ideas are rational and evidence-based, that is. Skeptical by nature, these personality types are especially drawn to offbeat or contrarian points of view. They’re even open to changing their own opinions when the facts prove them wrong.</li>

                            <li><strong>Versatile</strong> – Architects love diving into all sorts of challenges. Their curiosity and determination can help people with this personality type succeed in a wide range of endeavors.</li>

                        </ul>

                        <h2>Architect (INTJ) Weaknesses</h2>

                        <div className="scene"><img alt="Architect (INTJ) weaknesses" src={analysts_Architect_INTJ_weaknesses} /></div>

                        <ul>

                            <li><strong>Arrogant</strong> – Architects might be knowledgeable, but they’re not infallible. Their self-assurance can blind them to useful input from other people – especially anyone they deem to be intellectually inferior. These personalities can also become needlessly harsh or single-minded in trying to prove others wrong.</li>

                            <li><strong>Dismissive of Emotions</strong> – For Architects, rationality is king. But emotional context often matters more than people with this personality type care to admit. Architects can get impatient with anyone who seems to value feelings more than facts. Unfortunately, ignoring emotion is its own type of bias – one that can cloud Architects’ judgment.</li>

                            <li><strong>Overly Critical</strong> – These personalities tend to have a great deal of self-control, particularly when it comes to thoughts and feelings. When the people in their lives fail to match their level of restraint, Architects can become scathingly critical. But this criticism is often unfair, based on arbitrary standards rather than a full understanding of human nature.</li>

                            <li><strong>Combative</strong> – Architects hate blindly following <em>anything</em> without understanding why. This includes restrictions and the authority figures who impose them. People with this personality type can get caught up in arguing about useless rules and regulations – but sometimes these battles are distractions from more important matters.</li>

                            <li><strong>Romantically Clueless</strong> – Architects’ relentless rationality can lead them to be frustrated by romance. Especially in the early stages of a relationship, they may struggle to understand what’s going on and how to behave. And if their relationships fall apart for reasons they don’t understand, they can become cynical about matters of the heart, even questioning the importance of love and connection.</li>

                        </ul>

                        <div className="number">02</div>
                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/architect-intj-personality' className='next-feature'>
                            Introduction
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/personality-types/architect-intj-relationships-dating' className='next-feature'>
                            Romantic Relationships
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default intj_strengths_and_weaknesses
